import styled from "styled-components";
import {
  ShieldCheck,
  DeviceMobile,
  Medal,
  IdentificationCard,
  UsersThree,
  MagnifyingGlass,
} from "@phosphor-icons/react";

import QuickRegistration from "./Registration/QuickRegistration";
import Reveal from "./Shared/Reveal";
import { Container, Section, H2, Lead } from "./Shared/ui";

const REASONS = [
  { icon: ShieldCheck, text: "The most dependable matrimony service" },
  { icon: DeviceMobile, text: "100% verified mobile numbers" },
  { icon: Medal, text: "Trusted service for more than 12 years" },
  { icon: IdentificationCard, text: "The profiles are genuinely verified" },
  { icon: UsersThree, text: "Helps to find the right partner and family" },
  { icon: MagnifyingGlass, text: "Personalized searching options available" },
];

const RegisterSection = () => {
  return (
    <Section id="register">
      <Container>
        <Layout>
          <Intro>
            <Reveal>
              <H2>Begin your success story</H2>
              <Lead>
                Vinayaka Matrimony is a trend setter in finding a perfect partner for you.
                The site gives you the right information about the right person, with all
                the essential features for sharing and accessing genuine information.
              </Lead>
            </Reveal>

            <Reveal index={1}>
              <ReasonsTitle>Why choose Vinayaka Matrimony</ReasonsTitle>
            </Reveal>
            <Reasons>
              {REASONS.map(({ icon: Icon, text }, i) => (
                <Reveal as="li" key={text} index={i + 2}>
                  <IconWrap>
                    <Icon size={22} weight="duotone" />
                  </IconWrap>
                  <span>{text}</span>
                </Reveal>
              ))}
            </Reasons>
          </Intro>

          <Reveal index={1}>
            <QuickRegistration />
          </Reveal>
        </Layout>
      </Container>
    </Section>
  );
};

const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(0, 1fr);
  gap: clamp(40px, 6vw, 88px);
  align-items: center;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

const Intro = styled.div`
  min-width: 0;
`;

const ReasonsTitle = styled.h3`
  font-size: 20px;
  margin: 36px 0 18px;
`;

const Reasons = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 24px;

  li {
    display: flex;
    align-items: center;
    gap: 14px;
    font-weight: 500;
    line-height: 1.45;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const IconWrap = styled.span`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: var(--surface-butter);
  color: var(--indigo);

  @media (prefers-color-scheme: dark) {
    color: var(--butter);
  }
`;

export default RegisterSection;
